import React, { useMemo, useState } from "react";
import layoutStyle from "../../index.module.scss";
import style from "./index.module.scss";
import { Button, Col, Input, message, Row } from "antd";
import Form, { FormInstance } from "rc-field-form";
import SubEmpty from "./components/SubEmpty";
import useModalHandler from "utils/useModalHandler";
import AddTopicModal from "../../index";
import {
    BaseQuestionType,
    checkQuestion,
    QuestionType
} from "service/exercise";
import { sum } from "utils/common";
import SubTopicList from "./components/SubTopicList";
import { ListField, ListOperations } from "rc-field-form/es/List";
import SubModalTitle from "./components/SubModalTitle";
import { toFixedNumber } from "../../../../../../../service/service";

interface SubTopicsProps {
    subTypes: BaseQuestionType[];
    form: FormInstance<QuestionType>;
}

export default function SubTopics({ subTypes, form }: SubTopicsProps) {
    const [, forceUpdate] = useState({});
    const modal = useModalHandler();

    const questions = form.getFieldValue("questions");

    const totalScore = useMemo(() => {
        return sum.apply(
            null,
            questions?.map((item: QuestionType) => item.score) || []
        );
    }, [questions]);

    function onOk(data: QuestionType, operations: ListOperations) {
        const subQuestions = form.getFieldValue("questions");

        if (subQuestions.length >= 100) {
            throw new Error("最多添加100道小题!");
        }

        checkQuestion(data);
        operations.add(data);
        message.success("添加成功!");
    }

    function renderList(fields: ListField[], operations: ListOperations) {
        return (
            <div>
                {fields.length < 100 && (
                    <Button
                        className={style.addBtn}
                        icon="plus-square"
                        type="link"
                        onClick={modal.open}
                        title="添加小题"
                    />
                )}

                <SubTopicList
                    subTopics={fields}
                    subTypes={subTypes}
                    lockAxis="y"
                    onRemove={operations.remove}
                    onUpdate={() => forceUpdate({})}
                    useDragHandle
                    helperClass={style.sortHelper}
                    onSortEnd={({ oldIndex, newIndex }) =>
                        operations.move(oldIndex, newIndex)
                    }
                />

                {fields.length === 0 && <SubEmpty onAdd={modal.open} />}

                {modal.render(
                    <AddTopicModal
                        title={
                            <SubModalTitle
                                title="添加小题"
                                parentTitle="添加题目"
                            />
                        }
                        types={subTypes}
                        onOk={data => onOk(data, operations)}
                    />
                )}
            </div>
        );
    }

    return (
        <Row gutter={[0, 20]} className={style.root}>
            <Col span={4} className={layoutStyle.label}>
                <i className={layoutStyle.required}>*</i> 小题
                <div className={layoutStyle.tip}>
                    共{questions?.length || 0}题，共
                    {toFixedNumber(totalScore, 1)}分
                </div>
            </Col>

            <Col span={18} offset={1}>
                <Form.List name="questions" initialValue={[]}>
                    {renderList}
                </Form.List>
            </Col>

            <Col span={4} className={layoutStyle.label}>
                <i className={layoutStyle.required}>*</i> 本题分值
            </Col>

            <Col span={2} offset={1}>
                <Input
                    width={10}
                    value={toFixedNumber(totalScore, 1)}
                    disabled
                />
            </Col>
        </Row>
    );
}
